import React from 'react'
import { ListGroup, ListGroupItem } from 'react-bootstrap'

import './index.css'

const ChatList = ({ chat }) => {
    if (!chat || !chat.length) return false
    
    return (
       <ListGroup className="chat-container ms-3">
           {chat.map(data => (
               <ListGroupItem className="text-start">
                   {data.time} 
                   <span className="ms-3 me-1">{data.sender}</span> 
                   {data.message}
                </ListGroupItem>
           ))}
       </ListGroup>
    )
}

export default ChatList
